import React from 'react'
import ResumePostion from '../../Components/ResumePosition'
import Stripe from '../../Components/Stripe'
// Update title to register page view with analytics
import useDocumentTitle from '../../Utilities/useDocumentTitle'

function Dap() {
  useDocumentTitle('Experience - DAP')
  const dapPositionsArray = [
    {
      title: 'Innovation Engineer',
      dates: 'Jan 2023 - Current',
      company: 'WalkMe Inc.',
      location: 'New York, NY',
      bullets: [
        'Designed and documented build patterns and frameworks to promote future scalability.',
        'Managed deprecation of outdated features while creating next generation solutions.'
      ]
    },
    {
      title: 'Solution Accelerator Design Engineer',
      dates: 'Feb 2021 - Dec 2022',
      company: 'WalkMe Inc.',
      location: 'New York, NY',
      bullets: [
        'Led cross-functional projects focusing on Solution Gallery expansion, resulting in over 100% increase in available content and engagement.',
        'Developed a new feedback initiative focused on internal and external stakeholders to inform product and template enhancements.',
        'Designed and delivered enablement and technical documentation.'
      ]
    },
    {
      title: 'Solution Engineer',
      dates: 'Aug 2019 - Feb 2021',
      company: 'WalkMe Inc.',
      location: 'New York, NY',
      bullets: [
        'Partnered with customers of all sizes as a trusted advisor and expert resource through all phases of their WalkMe implementation.',
        'Delivered high quality enablement, content development, and technical support in line with the company commitment to superior service.',
        'Provided value driven solutions while ensuring project delivery within budget.'
      ]
    }
  ]
  let experience = dapPositionsArray.map((item, i) => {
    return <ResumePostion key={i} props={item} />
  })
  return (
    <div className='experience-section my-4'>
      <h5 className='text-center'>Summary</h5>
      <p className='text-center'>
        In almost four years at WalkMe as a Solution Engineer and Solution
        Accelerator Design Engineer, I was responsible for building partnerships
        with key stakeholders, delivering technical enablement, and developing
        innovative solutions for a broad range of customers across various
        industries.
      </p>
      <p className='text-center'>
        As a Solution Accelerator Design Engineer, I focused on creating
        streamlined and scalable solutions that delivered faster ROI for our
        customers. By prioritizing these factors, we were able to help customers
        quickly realize the benefits of WalkMe's software and achieve their
        digital transformation goals.
      </p>
      <Stripe />
      <div className='row'>
        <div className='col-md-6'>{experience}</div>
        <div className='col-md-6'>
          <img
            src={require('../../Media/flatiron.jpg')}
            className='img-fluid'
            alt='mountains'
          />
        </div>
      </div>
      <Stripe />
    </div>
  )
}

export default Dap
